export default "__VITE_ASSET__DKtnQMVq__"